import { AccountingTypes, client, ResponseData } from '../galaxyClient';

export const getUserSubscriptions = async () => {
  const { data } = await client().accounting.GET('/v2/subscriptions/', {
    params: {
      query: {
        me: true,
      },
    },
  });
  return data;
};

type CreateStripeSubscriptionParams = {
  affiliateName?: string;
  contentfulLandingPageId: string;
  currencyCode: string;
  amount: number;
  externalImpacterIds?: string[];
  categoryIds?: string[];
  paymentMethodId: string;
  language?: string;
  user?: { email?: string; firstName?: string; lastName?: string; emailOptIn?: boolean };
  verificationToken?: string;
};

export const createStripeSubscription = async ({
  affiliateName,
  amount,
  categoryIds,
  currencyCode,
  paymentMethodId,
  language,
  user,
  contentfulLandingPageId,
  verificationToken,
}: CreateStripeSubscriptionParams) => {
  const { data } = await client().accounting.POST('/v2/providers/stripe/subscriptions/', {
    headers: {
      'x-request-check': verificationToken ?? '',
    },
    body: {
      affiliateName,
      currencyCode,
      amount,
      categoryIds,
      paymentMethodId,
      language,
      contentfulLandingPageId,
      user: {
        ...user,
        firstName: user?.firstName ?? '',
        lastName: user?.lastName ?? '',
        email: user?.email ?? '',
      },
    },
  });
  return data;
};

export const getSubscriptionReceipt = async (receipt?: string | number) => {
  if (!receipt) {
    throw new Error('Receipt is required');
  }

  const { data } = await client().accounting.GET('/v2/subscriptions/{externalId}/receipt', {
    params: {
      path: {
        externalId: receipt?.toString(),
      },
    },
  });

  return data;
};

export type SubscriptionResponse = ResponseData<AccountingTypes, '/v2/subscriptions/{id}', 'get'>;

export const getSubscriptionById = async (id: number) => {
  const { data } = await client().accounting.GET('/v2/subscriptions/{id}', {
    params: {
      path: {
        id: id?.toString(),
      },
    },
  });

  return data;
};

export const editSubscription = async ({
  subscriptionId,
  items,
}: {
  subscriptionId: number;
  items: { id?: number; amount?: number; deleted?: boolean }[];
}) => {
  const { data } = await client().accounting.PUT('/v2/subscriptions/{id}', {
    params: {
      path: {
        id: subscriptionId,
      },
    },
    body: {
      items,
    },
  });

  return data;
};
